import { styled } from '@mui/material/styles';
import BaseDetails from './Details';

export const Details = styled(BaseDetails)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));